import {
  FETCH_ALL_TRANSACTIONS,
  FETCH_ALL_TRANSACTIONS_SUCCESS,
  FETCH_ALL_TRANSACTIONS_FAILED,
  EDIT_TRANSACTION,
  EDIT_TRANSACTION_SUCCESS,
  EDIT_TRANSACTION_FAILED,
  DELETE_TRANSACTION,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAILED,
} from "../store/types";

import { cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/transaction`;

export const fetchTransactions = () => (dispatch) => (firebase) => {

  dispatch({
    type: FETCH_ALL_TRANSACTIONS,
    payload: null
  });


  fetch(`${END_POINT}/fetch-transactions`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if(response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          return item;
        });

        dispatch({
          type: FETCH_ALL_TRANSACTIONS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_TRANSACTIONS_FAILED,
          payload: "No users available."
        });
      }
    }).catch(error => {
      dispatch({
        type: FETCH_ALL_TRANSACTIONS_FAILED,
        payload: "No users available."
      });
      console.log("fetchTransactions error", error)
    });

  // transactionsRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .map(i => {
  //         data[i].id = i;
  //         return data[i];
  //       });
  //     dispatch({
  //       type: FETCH_ALL_TRANSACTIONS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_ALL_TRANSACTIONS_FAILED,
  //       payload: "No users available."
  //     });
  //   }
  // });
};

export const addTransaction = (transdata) => (dispatch) => (firebase) => {
  // const {
  //   transactionsRef
  // } = Firebases;

  dispatch({
    type: EDIT_TRANSACTION,
    payload: transdata
  });

  fetch(`${END_POINT}/add-transaction`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ data: transdata })
  })
    .then(async (res) => {
      const response = await res.json();
      dispatch({
        type: EDIT_TRANSACTION_SUCCESS,
        payload: null
      });
      fetchTransactions()(dispatch)(firebase)
      // fetchBookings()(dispatch)(firebase)
      console.log("resp addTransaction", response)
    }).catch(error => {
      dispatch({
        type: EDIT_TRANSACTION_FAILED,
        payload: error.message
      });
      console.log("addTransaction error", error)
    });

  // transactionsRef.push(transdata).then((res) => {
  //   dispatch({
  //     type: EDIT_TRANSACTION_SUCCESS,
  //     payload: null
  //   });
  // }).catch((error) => {
  //   dispatch({
  //     type: EDIT_TRANSACTION_FAILED,
  //     payload: error
  //   });
  // });
}

export const editTransaction = (id, transaction) => (dispatch) => (firebase) => {

  const {
    singleTransactionRef
  } = firebase;

  dispatch({
    type: EDIT_TRANSACTION,
    payload: transaction
  });
  let editedTransaction = transaction;
  delete editedTransaction.id;
  singleTransactionRef(id).set(editedTransaction).then(() => {
    dispatch({
      type: EDIT_TRANSACTION_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_TRANSACTION_FAILED,
      payload: error
    });
  });
}

export const deleteTransaction = (id) => (dispatch) => (firebase) => {

  const {
    singleTransactionRef
  } = firebase;

  dispatch({
    type: DELETE_TRANSACTION,
    payload: id
  });

  singleTransactionRef(id).remove().then(() => {
    dispatch({
      type: DELETE_TRANSACTION_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: DELETE_TRANSACTION_FAILED,
      payload: error
    });
  });
}